import { render } from "./NewsHorizontal.vue?vue&type=template&id=600f19e3&scoped=true"
import script from "./NewsHorizontal.vue?vue&type=script&lang=js"
export * from "./NewsHorizontal.vue?vue&type=script&lang=js"

import "./NewsHorizontal.vue?vue&type=style&index=0&id=600f19e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-600f19e3"

export default script